module.exports = __webpack_public_path__ + "images/shuffle@1x.png?0fb28f58";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shuffle@1x.png
// module id = 701
// module chunks = 7